import { createSelector } from 'reselect';

import type { RootState } from '@/app/store';

const selectFeedState = (state: RootState) => state.feed;

export const selectFeedItems = createSelector(selectFeedState, (s) => s.items);
export const selectFeedLoading = createSelector(selectFeedState, (s) => s.loading);
export const selectLastPlayedGame = createSelector(selectFeedState, (s) => s.lastPlayedGame);
